export default __webpack_public_path__ + "locales/ko-KR/SharingPanel.json?hash=309ca9013c16e41cf4812def3acc1eab";